var _path, _path2, _path3, _path4, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFincab({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0877 5.6179L8.15029 5.61789C6.18435 5.61789 4.58923 7.24777 4.58923 9.24317L4.58923 20.7568C4.58923 22.7582 6.19024 24.3821 8.15029 24.3821L13.2054 24.3821C13.6468 24.3821 14 24.7416 14 25.1911C14 25.6405 13.6468 26 13.2054 26L8.15029 26C5.30733 26 3 23.6451 3 20.7568L3 9.24317C3 6.34894 5.31322 4 8.15029 4L13.0877 4.00001C13.5291 4.00001 13.8823 4.35953 13.8823 4.80895C13.8823 5.25837 13.5232 5.6179 13.0877 5.6179Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6179 15.9123L4.61789 20.8497C4.61789 22.8156 6.24777 24.4108 8.24317 24.4108L20.7568 24.4108C22.7582 24.4108 24.3821 22.8098 24.3821 20.8497L24.3821 16.7946C24.3821 16.3532 24.7416 16 25.1911 16C25.6405 16 26 16.3532 26 16.7946L26 20.8497C26 23.6927 23.6451 26 20.7568 26L8.24317 26C5.34894 26 3 23.6868 3 20.8497L3.00001 15.9123C3.00001 15.4709 3.35953 15.1177 3.80895 15.1177C4.25837 15.1177 4.6179 15.4768 4.6179 15.9123Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.183 4.00001L18.9376 4.01811C18.4283 4.01922 18.0208 4.42855 18.0219 4.93788C18.023 5.44721 18.4323 5.85474 18.9416 5.85362L22.9767 5.84038L17.7189 11.0058C17.3593 11.367 17.3606 11.9436 17.7217 12.3032C18.0829 12.6628 18.6595 12.6615 19.0191 12.3004L24.2769 7.13488L24.2902 11.17C24.2913 11.6793 24.7006 12.0868 25.2099 12.0857C25.4598 12.0852 25.695 11.9838 25.858 11.82C26.0211 11.6563 26.1263 11.4254 26.1209 11.1708L26.1028 4.92537C26.1017 4.40642 25.6875 3.9941 25.183 4.00001Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 9.44772 8.44772 9 9 9C9.55228 9 10 9.44772 10 10V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V10Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18,
    width: 2,
    height: 4,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 2,
    height: 6,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFincab);
export default __webpack_public_path__ + "static/media/fincab.27e88c6b38ea76dc5514cae86ab3f583.svg";
export { ForwardRef as ReactComponent };